import { createContext } from "react";

import type usePersonnelIdentityById from "src/hooks/data/load/usePersonnelIdentityById";

/**
 * Describes the personnel identity loader state and its refresh/cache actions.
 */
export interface IPersonnelIdentityContext extends ReturnType<typeof usePersonnelIdentityById> {}

/**
 * Shares personnel identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export const PersonnelIdentityContext = createContext<IPersonnelIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});

export default PersonnelIdentityContext;
